var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWpIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_2409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.003 0H11.997C5.3805 0 0 5.382 0 12C0 14.625 0.846 17.058 2.2845 19.0335L0.789 23.4915L5.4015 22.017C7.299 23.274 9.5625 24 12.003 24C18.6195 24 24 18.6165 24 12C24 5.3835 18.6195 0 12.003 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7498 16.2574C18.4646 17.0607 17.3327 17.7269 16.4298 17.9214C15.8121 18.0526 15.0053 18.1573 12.2894 17.0342C8.81535 15.5986 6.57816 12.0775 6.40379 11.8491C6.23681 11.6206 5 9.98464 5 8.29263C5 6.60063 5.86148 5.77673 6.20874 5.423C6.49393 5.13265 6.96531 5 7.41748 5C7.56377 5 7.69528 5.00737 7.81349 5.01326C8.16075 5.028 8.33511 5.04864 8.56415 5.59544C8.84934 6.2808 9.54385 7.9728 9.6266 8.14672C9.71083 8.32064 9.79505 8.55645 9.67684 8.78491C9.56601 9.02072 9.46849 9.12537 9.29412 9.32582C9.11976 9.52626 8.95426 9.67955 8.77989 9.89473C8.6203 10.0819 8.44003 10.2824 8.64099 10.6287C8.84195 10.9677 9.53646 12.0982 10.559 13.0061C11.8786 14.1778 12.9484 14.5522 13.3311 14.7113C13.6163 14.8293 13.9562 14.8013 14.1645 14.5802C14.429 14.2957 14.7556 13.8241 15.0881 13.3598C15.3245 13.0267 15.623 12.9854 15.9363 13.1034C16.2554 13.2139 17.9444 14.0466 18.2917 14.2191C18.6389 14.393 18.868 14.4755 18.9522 14.6214C19.035 14.7674 19.035 15.4527 18.7498 16.2574Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_2409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpIcn);
export default __webpack_public_path__ + "static/media/wp-icn.4323e5b64e67bfb68b5f6ef1d3f9d0ef.svg";
export { ForwardRef as ReactComponent };